import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { GetPunchoutApiParameter } from "@TKCCP/Services/tkccpPunchoutService";
import { PunchoutSecretServiceState } from "@TKCCP/Store/Data/PunchoutSecretService/PunchoutSecretServiceState";
import { PunchoutServiceCollectionModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: PunchoutSecretServiceState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const reducer = {
    "Data/PunchoutSecretService/BeginLoadPunchout": (
        draft: Draft<PunchoutSecretServiceState>,
        action: { parameter: GetPunchoutApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Data/PunchoutSecretService/CompleteLoadPunchout": (
        draft: Draft<PunchoutSecretServiceState>,
        action: { parameter: GetPunchoutApiParameter; collection: PunchoutServiceCollectionModel },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.punchOutSecretCollection!,
            //  punchout => storeIdByOrderNumber(draft, punchout),
        );
    },
    "Data/PunchoutSecretService/Reset": () => {
        return initialState;
    },
};

const punchoutsecretreducer = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).datapunchoutsecret = punchoutsecretreducer;
